import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import type { ShopSummary } from '../../api/types.ts';
import { formatLocalDateTime } from '../dashboard/dashboardHelpers.ts';
import { DetailRow } from './DetailRow.tsx';
import { formatClockSkew } from './shopHealthHelpers.ts';
import { isClockSkewWarning } from './shopsHelpers.ts';

export interface ShopSyncHealthCardProps {
  shop: ShopSummary;
}

export function ShopSyncHealthCard({ shop }: Readonly<ShopSyncHealthCardProps>): React.JSX.Element {
  const skewWarn = isClockSkewWarning(shop.last_clock_skew_ms);

  return (
    <Paper sx={{ p: 2.5 }}>
      <Typography variant="h6" gutterBottom>
        Technical details
      </Typography>
      {/* Both rows are moments, not calendar dates (E2.1 spec 4.6): one shared formatter, or the pair reads skewed. */}
      <DetailRow
        label="Key registered"
        value={shop.key_registered_at ? formatLocalDateTime(shop.key_registered_at) : 'no key registered'}
      />
      <DetailRow label="Last sync" value={shop.last_sync_at ? formatLocalDateTime(shop.last_sync_at) : 'never'} />
      <DetailRow label="Last acked sequence" value={String(shop.last_acked_seq)} />
      <DetailRow
        label="Recovery ticket counter"
        value={shop.last_counter_value === null ? '-' : String(shop.last_counter_value)}
      />
      <DetailRow label="Last clock difference" value={formatClockSkew(shop.last_clock_skew_ms)} />
      {skewWarn && (
        <Alert severity="info" variant="outlined" sx={{ mt: 1 }}>
          Sync corrected for this clock difference. Investigate if it continues.
        </Alert>
      )}
    </Paper>
  );
}

export default ShopSyncHealthCard;
